import { useEffect } from 'react';

import {
  usePerformanceTracking,
  useTrackReady,
} from '@adsk/exo-skeleton-react';

const usePerformanceTrackingWithEffects = ({
  trackingId,
  loading,
  executeTrackReady,
  displayName,
  parentTrackingId,
}: {
  trackingId: string;
  parentTrackingId?: string;
  loading?: boolean;
  executeTrackReady?: boolean;
  displayName?: string;
}) => {
  const { trackReadyOnce } = useTrackReady();
  const { startTracking, endTracking } = usePerformanceTracking({
    trackingId,
    parentTrackingId,
  });

  useEffect(() => {
    startTracking();
  }, [startTracking]);

  useEffect(() => {
    if (!loading) {
      endTracking();

      if (executeTrackReady) {
        trackReadyOnce({
          metadata: {
            displayName,
          },
        });
      }
    }
  }, [loading, trackReadyOnce, displayName, endTracking, executeTrackReady]);
};

export default usePerformanceTrackingWithEffects;
